import { TODO_TYPE } from '@/_legacy/constants';
import { TodoRecord } from '@/entities/todo';
import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';
import { router } from '@/ui/routes';

const isInspection = (type: number) => type === TODO_TYPE.INSPECTION;

export const openTodo = (todo: TodoRecord) => {
  const name = isInspection(todo.data.type)
    ? todo.authorizedTo.update ? 'inspectionEdit' : 'inspectionDetail'
    : 'issueEdit';
  const params = isInspection(todo.data.type)
    ? { id: String(todo.data.inspection?.id) }
    : { id: String(todo.data.issue?.id) };

  trackClick(CLICK_EVENTS.TILES.ITEMS.ASSIGNED_TO_YOU);

  if (todo.authorizedTo.update || todo.authorizedTo.view) {
    router.push({ name, params });
  }
};
